import { COMPLETION_PERC } from 'shared/constants'
import { ILesson, ISectionTestSyncTranslate } from 'shared/types'
import reduce from 'lodash/reduce'
import { isTestSection } from 'shared/utils/sectionName'
import words from 'lodash/words'
import toLower from 'lodash/toLower'
import map from 'lodash/map'
import get from 'lodash/get'
import size from 'lodash/size'
import isNumber from 'lodash/isNumber'
import { SectionType } from 'shared/types'

export const percToAmount = (testsAmount: number, perc?: number) => {
  const v = isNumber(perc) ? perc : COMPLETION_PERC
  const res = Math.ceil((testsAmount / 100) * v)
  // console.log(
  //   'percToAmount, testsAmount',
  //   testsAmount,
  //   'perc',
  //   perc,
  //   'res',
  //   res
  // )
  return res
}

export const getTestQuestionsAmount = (l: ILesson) => {
  return reduce(
    l.sections,
    (res, s) => {
      if (isTestSection(s.type)) {
        switch (s.type) {
          case SectionType.TEST_LINK_BY_MEANING:
          case SectionType.TEST_MATCH_WORDS_WITH_IMAGES: {
            const words = size(s.test?.matching)
            return res + words
          }
          case SectionType.TEST_ADD_WORDS:
          case SectionType.TEST_ARRANGE_WORDS: {
            const str = s.test?.text || ''
            const words = size(str.match(/\{(.*?)\}/g))
            return res + words
          }
          case SectionType.TEST_SYNC_TRANSLATE: {
            const t = s as ISectionTestSyncTranslate
            const tasksAmount = reduce(
              t.test?.syncTranslate,
              (res, p) => {
                const str = p.task || ''
                const words = size(str.match(/\{(.*?)\}/g))
                return res + words
              },
              0
            )
            return res + tasksAmount
          }
          default:
            return res + 1
        }
      } else {
        return res
      }
    },
    0
  )
}

export const cleanupString = (s: string, makeLower = true) => {
  const wrds = makeLower ? words(toLower(s)) : words(s)
  const strAr = map(wrds, (w) =>
    w.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  )
  return strAr.join(' ')
}

export const displayString = (s: string, makeLower = true) => {
  const withoutBraces = s.replace(/[{}]/g, '')
  const firstAlternative = withoutBraces.split('/')[0]
  const withSpaces = firstAlternative.replace(/_/g, ' ').trim()
  return makeLower ? toLower(withSpaces) : withSpaces
}

export const testTitles = {
  [SectionType.TEST_ONE_OPTION]:
    'Выберите один правильный варианта перевода фразы',
  [SectionType.TEST_TRUE_FALSE]: 'Верно ли утверждение',
  [SectionType.TEST_TEXT_ANSWER]: 'Напишите верный перевод предложения',
  [SectionType.TEST_INPUT_ANSWER]: 'Напишите верный перевод слова',
  [SectionType.TEST_BUTTONS]:
    'Выберите один правильный варианта перевода слова',
  [SectionType.TEST_ADD_WORDS]: 'Заполните пропуски в тексте',
  [SectionType.TEST_ADD_LETTERS]: 'Вставьте пропущенные буквы',
  [SectionType.TEST_SYNC_TRANSLATE]: 'Заполните пропуски в тексте',
  [SectionType.TEST_ARRANGE_WORDS]:
    'Перетащите ответ на место пробелов в тексте',
  [SectionType.TEST_LINK_BY_MEANING]: 'Выберите соответсвующую пару слов',
  [SectionType.TEST_MATCH_WORDS_WITH_IMAGES]: 'Сопоставьте слова и картинки'
}

export const getTestTitle = (t: SectionType) => {
  return get(testTitles, t, '')
}
